module.exports = __webpack_public_path__ + "static/media/Week 1 Saturday.5f9fdbf9.png";